import { HeaderIcon } from 'components/mobile/organisms';
import { useFeatureFlags, useLocation } from 'contexts';
import { useRegionPicker } from 'hooks';
import { SlotComponentProps } from 'modules/page-builder/types';

export type HeaderRightItemProps = SlotComponentProps<{}>;

export const HeaderRightItemMobile: React.FC<HeaderRightItemProps> = ({}) => {
  const { flags } = useFeatureFlags();
  const locationPickerProps = useLocation();
  const { isShowed: isShowedLocationPopup, setShowed: showLocationPopup } =
    locationPickerProps;

  const regionPickerProps = useRegionPicker();

  return (
    <HeaderIcon
      isVisible={true}
      showRegionPopup={
        flags.epic_ecom_284
          ? isShowedLocationPopup
          : regionPickerProps.showPopup
      }
      setShowRegionPopup={
        flags.epic_ecom_284 ? showLocationPopup : regionPickerProps.setShowPopup
      }
      isShowCartIcon
    />
  );
};
